<template>
  <div>
    <!--
    <div class="text-right">
      <vs-button @click="repeateAgain">Add New Question</vs-button>
    </div>
    -->
    <vs-card
      class="mt-5 px-5"
      v-for="(item, index) in items"
      :id="item.id"
      :key="item.id"
      v-bind:class="{
        removed: item.removed,
        disabled: !item.field_status,
      }"
    >
      <!--
      <vs-row vs-w="12">
        <vs-col vs-w="12">
          <div class="mt-0 text-right">
            <vs-button
              v-if="!item.removed"
              type="border"
              size="small"
              class="mr-2"
              @click="removeItem(index)"
              ><i class="fas fa-trash-alt"></i
            ></vs-button>
            <vs-button
              v-else
              type="border"
              size="small"
              class="mr-2"
              @click="redoItem(index)"
              ><i class="fas fa-redo"></i
            ></vs-button>
          </div>
        </vs-col>
      </vs-row>
      -->
      <vs-row vs-w="12">
        <vs-col vs-justify="left" vs-align="center" vs-w="9">
          <div class="my-4 w-4/5">
            <label>Type</label>
            <!-- <div class="con-selects">
              <vs-select v-model="item.field_type" @change="onTypeChanged(index)">
                <vs-select-item :key="index" :value="option.value" :text="option.text" v-for="(option, index) in options" />
              </vs-select>
            </div> -->
            <b-form-select
              @change="onTypeChanged(index)"
              style="height: 42px"
              v-model="item.field_type"
              :options="options"
            ></b-form-select>
          </div>

          <div class="my-4">
            <label>Title</label>
            <vs-input v-model="item.field_q" style="width: 90%" />
            <div class="my-3">
              <label>Description</label>
              <vs-input v-model="item.field_desc" style="width: 90%" />
            </div>

            <div
              class="pl-5 mt-5"
              v-if="['radio', 'checkbox', 'select'].includes(item.field_type)"
            >
              <vs-row
                class="my-2"
                vs-w="12"
                :key="j"
                v-for="(option, j) in item.options"
              >
                <vs-col vs-w="1">
                  <vs-radio class="mt-3" disabled></vs-radio>
                </vs-col>
                <vs-col vs-w="7">
                  <vs-input
                    v-model="option.text"
                    :disabled="option.text == 'Other'"
                    style="width: 90%"
                  />
                </vs-col>
                <vs-col vs-w="4">
                  <vs-button
                    class="mr-2"
                    type="border"
                    icon="close"
                    @click="removeOpton(index, j)"
                  ></vs-button>
                </vs-col>
              </vs-row>
              <vs-row
                class="my-2"
                vs-w="12"
                v-if="items[index].other"
              >
                <vs-col vs-w="1">
                  <vs-radio class="mt-3" disabled></vs-radio>
                </vs-col>
                <vs-col vs-w="7">
                  <vs-input value="Other" :disabled="true" style="width: 90%" />
                </vs-col>
                <vs-col vs-w="4">
                  <vs-button
                    class="mr-2"
                    type="border"
                    icon="close"
                    @click="removeOther(index, item)"
                  ></vs-button>
                </vs-col>
              </vs-row>
              <vs-row vs-w="12" class="mt-5">
                <vs-col vs-w="1"> </vs-col>
                <!--
                  <vs-col vs-w="7">
                    <vs-input style="width:90%;" disabled />
                  </vs-col>
                  -->
                <vs-col vs-w="11">
                  <vs-button
                    style="display: inline-block"
                    type="border"
                    @click="addOpton(index)"
                    >Add option</vs-button
                  >
                  <template
                    v-if="!items[index].other"
                  >
                    <span class="px-3">or</span>
                    <vs-button
                      style="display: inline-block"
                      type="border"
                      @click="addOpton(index, true)"
                      >Add "Other"</vs-button
                    >
                  </template>
                </vs-col>
              </vs-row>
            </div>

            <div class="pl-5 mt-5" v-if="['rank'].includes(item.field_type)">
              <vs-row
                class="my-2"
                vs-w="12"
                :key="j"
                v-for="(option, j) in item.options"
              >
                <vs-col vs-w="1">
                  <vs-radio class="mt-3" disabled></vs-radio>
                </vs-col>
                <vs-col vs-w="7">
                  <vs-input
                    v-model="option.text"
                    :disabled="option.text == 'Other'"
                    style="width: 90%"
                  />
                </vs-col>
                <vs-col vs-w="4">
                  <vs-button
                    class="mr-2"
                    type="border"
                    icon="close"
                    @click="removeOpton(index, j)"
                  ></vs-button>
                </vs-col>
              </vs-row>
              <vs-row vs-w="12" class="mt-5">
                <vs-col vs-w="1"> </vs-col>
                <!--
                  <vs-col vs-w="7">
                    <vs-input style="width:90%;" disabled />
                  </vs-col>
                  -->
                <vs-col vs-w="11">
                  <vs-button
                    style="display: inline-block"
                    type="border"
                    @click="addOpton(index)"
                    >Add option</vs-button
                  >
                  <!-- <template v-if="!items[index].options.find(e => e.text === 'Other')">
                    <span class="px-3">or</span>
                    <vs-button style="display: inline-block" type="border" @click="addOpton(index, true)">Add
                      "Other"</vs-button>
                  </template> -->
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-col>
        <vs-col vs-justify="left" vs-align="center" vs-w="3">
          <div class="my-2">
            <label>Status</label>
            <vs-switch class="mt-2" v-model="item.field_status" />
          </div>
          <div class="my-4">
            <label>Is Required?</label>
            <vs-switch class="mt-2" v-model="item.field_required" />
          </div>
          <div class="my-4">
            <label>Weight (0-1000)</label>
            <vs-input
              v-validate="{ min_value: 0, max_value: 1000 }"
              v-model="item.field_weight"
              style="width: 90%"
              name="weight"
            />
            <span class="text-danger text-sm" v-show="errors.has('weight')">{{
              errors.first("weight")
            }}</span>
          </div>
        </vs-col>
        <!--
          <vs-col vs-justify="right" vs-align="right" vs-w="1">
            <div class="mt-2">
              <label></label>
              <div class="mt-0">
                <vs-button
                  class="mr-2"
                  type="border"
                  icon="trash"
                  @click="removeItem(index)"
                ></vs-button>
              </div>
            </div>
          </vs-col>
          -->
      </vs-row>
    </vs-card>
    <!--
    <draggable
      :list="items"
      tag="ul"
      group="people"
      class="list-group list-group-flush cursor-move"
    >
    </draggable>
    -->
    <div class="vx-row pt-5">
      <div class="vx-col w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="validateForm">Submit</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  props: ["e", "event", "field_status", "basicForm", "onSubmit"],
  computed: {
    ...mapState({
      accessToken: (state) => {
        return state.Auth.accessToken;
      },
    }),
  },
  data() {
    return {
      options: [
        { text: "Short answer", value: "text" },
        { text: "Number", value: "number" },
        { text: "National ID", value: "citizenid" },
        { text: "Paragraph", value: "textarea" },
        { text: "Date", value: "date" },
        { text: "Birthdate", value: "birthdate" },
        { text: "Multiple choice", value: "radio" },
        { text: "Checkboxes", value: "checkbox" },
        { text: "Dropdown", value: "select" },
        { text: "Country", value: "country" },
        { text: "Province (Thailand)", value: "province-thailand" },
        { text: "Image Upload", value: "uploadimage" },
        { text: "Rank", value: "rank" },
        // { text: "Location (latitude, longitude)", value: "map" },
        // { text: "Travel Distance", value: "distance" },
      ],
      items: [],
      nextTodoId: 2,
    };
  },
  created() {
    let hasExist = false;
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key) => {
      if (true) {
        let status = this.event["field_status" + key];
        if (this.event["field_type" + key] == null) {
          status = false;
        }
        this.items.push({
          field_q: this.event["field_q" + key],
          field_opt: this.event["field_opt" + key],
          field_desc: this.event["field_desc" + key],
          field_type: this.event["field_type" + key],
          field_status: status,
          field_required: this.event["field_required" + key],
          field_weight: this.event["field_weight" + key],
          options: [],
          other: false,
          removed: false,
          can_delete: false,
        });
        hasExist = true;
      }
    });

    if (!hasExist) {
      let data = {};
      data["field_q"] = "";
      data["field_opt"] = null;
      data["field_desc"] = "";
      data["field_type"] = "radio";
      data["field_status"] = true;
      data["can_delete"] = true;
      data["options"] = [];
      this.items.push(data);
    }

    this.items.map((item) => {
      if (item.field_opt != null) {
        let o = item.field_opt.split(";");
        o.map((o) => {
          item["options"].push({ text: o });
        });
      }
    });
  },
  methods: {
    onTypeChanged(index) {
      const item = this.items[index];
      if (
        ["radio", "checkbox", "rank"].includes(item.field_type) &&
        (!item.options || item.options.length < 1)
      ) {
        this.addOpton(index);
      }
    },
    repeateAgain() {
      if (this.items.length < 10) {
        let data = {};
        data["field_q"] = "";
        data["field_opt"] = null;
        data["field_desc"] = "";
        data["field_type"] = "text";
        data["field_status"] = true;
        data["can_delete"] = true;
        this.items.push({
          ...data,
        });
      }

      /*
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
      */
    },
    removeItem(index) {
      this.items[index].removed = true;
      //this.items.splice(index, 1);
      //this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    redoItem(index) {
      this.items[index].removed = false;
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submit();
        }
      });
    },
    submit() {
      // this.$vs.loading();

      if (this.items.length < 1) {
        return;
      }
      let weight = [100, 200, 300, 400, 500, 600, 700, 800, 900, 999];
      let arrs = [];
      let arr_no = 1;
      this.items.map((item, index) => {
        let data = {};
        let field_required = null;
        if (item.field_required) {
          field_required = 1;
        }

        let field_status = 1;
        if (item.removed || !item.field_status || item.field_status == null) {
          field_status = null;
        }

        console.log(field_status);
        data["field_q" + arr_no] = item.field_q;
        data["field_opt" + arr_no] = item.field_opt;
        data["field_desc" + arr_no] = item.field_desc;
        if (
          item.other &&
          item.options &&
          item.options.length > 0 &&
          (item.field_type == "checkbox" || item.field_type == "radio")
        ) {
          data["field_type" + arr_no] = item.field_type + "withother";
        } else {
          data["field_type" + arr_no] = item.field_type;
        }
        data["field_status" + arr_no] = field_status;
        data["field_required" + arr_no] = field_required;
        data["field_weight" + arr_no] = item.field_weight;

        if (item.options) {
          if (item.options.length > 0) {
            let o = [];
            item.options.map((opt) => {
              o.push(opt.text);
            });
            data["field_opt" + arr_no] = o.join(";");
          }
        }

        arrs.push(data);
        arr_no++;
      });

      Service.Event.update({
        e: this.e,
        customfields: arrs,
        fields_status: this.field_status,
        ...this.basicForm,
      })
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          if (this.onSubmit) {
            this.onSubmit();
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
        });
    },
    addOpton(index, other = false) {
      if (!other) {
        this.items[index].options.push({
          text: "",
        });
      } else {
        this.items[index].other = true;
        // this.items[index].options.push({
        //   text: "Other",
        // });
      }
      const newitems = [];
      // let hasOther = false
      for (const item of this.items[index].options) {
        // if (item.text != "Other") {
        //   newitems.push({
        //     text: item.text,
        //   });
        // } else {
        //   hasOther = true
        // }
        newitems.push({
          text: item.text,
        });
      }
      // if (hasOther) {
      //   newitems.push({
      //     text: "Other",
      //   });
      // }
      this.items[index].options = newitems;
    },
    removeOpton(index, j) {
      this.items[index].options.splice(j, 1);
    },
    removeOther(index, item) {
      // this.items[index].other = false;
      this.$nextTick(() => {
        this.items[index].other = false;
      });
    },
  },
};
</script>
<style lang="scss">
.removed,
.disabled {
  background-color: #eee;
}
</style>
